<template>
	<div>
      <!-- <div v-html="svgContent"> </div> -->
      <div v-if="vcamItem">
        <div v-if="!vcamItem.is_ndiInput">
            <vue-draggable-resizable
            :style="style"
            class="element-position-lowerthird "
            v-if="status==='preview' && vcamItem.is_power"
            :draggable="status ==='preview'"
            :resizable="status ==='preview'"
            :w="vcamItem.width"
            :h="vcamItem.height"
            @dragstop="onDragstop"
            @resizestop="onResizestop"
            @dragging="onDrag"
            @resizing="onResize"
            :preventActiveBehavior="true"
            :parent="false">
              <iframe
                  loading="eager"
                  :id="`panelistifrmpreview${orderItem}`"
                  v-if="status==='preview' && vcamItem.is_power"
                  class="nineteentwenty"
                  v-show="!vcamItem.is_empty_feed"
                  :src="convertURL(vcamItem.url)" frameborder="0"
                  style="pointer-events: none; z-index:0;"
                  :style="style"
                  allow="autoplay;camera;microphone" allowfullscreen>
              </iframe>
            </vue-draggable-resizable>
            <!-- <iframe
                loading="eager"
                :id="`panelistifrmpreview${orderItem}`"
                v-if="status==='preview' && vcamItem.is_power"
                class="nineteentwenty"
                v-show="!vcamItem.is_empty_feed"
                :src="vcamItem.url" frameborder="0"
                style="pointer-events: none;"
                allow="autoplay;camera;microphone" allowfullscreen></iframe> -->
            <iframe loading="eager"
            :id="`panelistifrmlive${orderItem}`" v-if="status==='live'" class="nineteentwenty" v-show="!vcamItem.is_empty_feed"
            :src="convertURL(vcamItem.url)" frameborder="0"
            allow="autoplay;camera;microphone" allowfullscreen></iframe>
        </div>
      </div>
  </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable';
import {
	delay,
} from '@/lib/helper';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';

export default {
	name: 'ElementVCam',
	props: {
		vcamItem: {
			type: Object,
		},
		status: {
			type: String,
		},
		orderItem: {

		},
		layerIndex: {

		},
	},
	components: {
		'vue-draggable-resizable': VueDraggableResizable,
	},
	sockets: {
	},
	created() {

	},
	mounted() {
		// const isMuteAll = this.content.isMutedAll;
		// for (let index = 0; index <style this.virtualCams.length; index++) {
		const item = this.vcamItem;
		// console.log(item);
		if (this.status === 'live' && !item.is_power) {
			this.removeItem(item.id);
		}
		if (!item.is_ndi) {
			delay(() => {
				const iframeLive = document.getElementById(`panelistifrmlive${item.order}`);
				const iframePreview = document.getElementById(`panelistifrmpreview${item.order}`);
				if (iframeLive && item.is_power) iframeLive.contentWindow.postMessage({ mute: item.is_mute || (item.is_empty_feed && item.is_hide_label) }, '*'); // only work for obs ninja
				if (iframePreview && item.is_power) iframePreview.contentWindow.postMessage({ mute: item.is_mute || (item.is_empty_feed && item.is_hide_label) }, '*'); // only work for obs ninja
			}, 1000);
			// const css = `<style type="text/css" id="style-panelistifrmpreview${item.order}">${item.custom_css}</style>`;
			// if (this.status === 'preview') {
			// 	const myiFrame = document.getElementById(`panelistifrmpreview${item.order}`);
			// 	const doc = myiFrame.contentDocument;
			// 	// eslint-disable-next-line operator-assignment
			// 	doc.body.innerHTML += css;
			// }
		}
		// }
	},
	beforeDestroy() {
	},
	data() {
		return {
			localItem: {},
		};
	},
	methods: {
		onDragstop() {
			// console.log('asdasdasd');
		},
		onResizestop() {

		},
		onDrag() {
			// console.log('asdasdasd');
		},
		onResize() {

		},
		// mute() {
		// 	const iframeLive = document.getElementById(`panelistifrmlive${this.localItem.order}`);
		// 	const iframePreview = document.getElementById(`panelistifrmpreview${this.localItem.order}`);
		// 	this.localItem.is_mute = true;
		// 	delay(() => {
		// 		if (iframeLive) iframeLive.contentWindow.postMessage({ mute: true }, '*'); // only work for obs ninja
		// 		if (iframePreview) iframePreview.contentWindow.postMessage({ mute: true }, '*'); // only work for obs ninja
		// 	}, 500);
		// },
		// unmute() {
		// 	const iframePreview = document.getElementById(`panelistifrmpreview${this.localItem.order}`);
		// 	const iframeLive = document.getElementById(`panelistifrmlive${this.localItem.order}`);
		// 	this.localItem.is_mute = false;
		// 	delay(() => {
		// 		if (iframeLive) iframeLive.contentWindow.postMessage({ mute: false }, '*'); // only work for obs ninja
		// 		if (iframePreview) iframePreview.contentWindow.postMessage({ mute: false }, '*'); // only work for obs ninja
		// 	}, 500);
		// },
		attachCss() {
			// console.log(vcamItem);
		},
		convertURL(url) {
			let resultUrl = url;
			// check youtube only
			if (resultUrl.includes('https://www.youtu') || resultUrl.includes('https://youtu')) {
				const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
				const match = resultUrl.match(regExp);
				// eslint-disable-next-line
				if (match && match[2].length == 11) {
					return `https://www.youtube.com/embed/${match[2]}?autoplay=1`;
				}
			}
			// check vimeo only
			if (resultUrl.includes('https://vimeo')) {
				const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
				const match = resultUrl.match(regExp);
				// eslint-disable-next-line
				if (match) {
					return `https://player.vimeo.com/video/${match[5]}?autoplay=1`;
				}
				return 'error';
			}
			if (resultUrl.includes('https://player.vimeo')) resultUrl = `${resultUrl}?autoplay=1`;
			return resultUrl;
		},
	},
	computed: {
		style() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.width = `${this.vcamItem && this.vcamItem.width ? this.vcamItem.width : 0}px`;
			style.height = `${this.vcamItem && this.vcamItem.height ? this.vcamItem.height : 0}px`;

			return style;
		},
	},
	watch: {
		// vcamItem() {
		// 	const item = this.vcamItem;
		// 	const css = `<style type="text/css" id="style-panelistifrmpreview${item.order}">${item.custom_css}</style>`;
		// 	if (this.status === 'preview') {
		// 		$(`panelistifrmpreview${item.order}`).contents().find('head').append(css);
		// 	}
		// },
	},
};
</script>

<style lang="css" v-html="" scoped>
@import url("https://fonts.googleapis.com/css?family=Open+Sans+Condensed:300");
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  background-image: linear-gradient(rgba(200, 200, 200, 0.1) 0.1em, transparent 0.1em), linear-gradient(90deg, rgba(200, 200, 200, 0.1) 0.1em, transparent 0.1em);
  background-size: 10px 50px;

}

.twelveeighty {
  width: 1280px !important;
  height: 720px !important;
}

.nineteentwenty {
  width: 1920px !important;
  height: 1080px !important;
}

button {
  height: 50px;
  background-color: #00FF00;
}

#buttonbar {
  position: absolute;
  bottom: 20px;
  left: 100px;
  z-index: 99999 !important;
}
</style>
